import { useContext } from 'react'
import { ThemeContext } from '@contexts/Theme/context'

export const useTheme = () => {
  const ctx = useContext(ThemeContext)
  return ctx
}
